import React, { useContext } from 'react';
import { store } from './store';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

const appBarSx = {
	position: 'relative'
};

const titleSx = theme => ({
	marginLeft: theme.spacing(2),
	flex: 1
});

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function FullScreenDialog({
	title,
	dlgCmp,
	open,
	sx,
	options,
	fullScreen = true
}) {
	const { dispatch } = useContext(store);

	const handleClose = (event, reason) => {
		console.log('reason', reason, options);

		if (options?.disableBackdropClose && reason === 'backdropClick') {
			return;
		}
		dispatch({ type: 'close dialog' });
	};

	return (
		<Dialog
			sx={sx}
			fullScreen={fullScreen}
			open={open}
			onClose={handleClose}
			TransitionComponent={Transition}>
			<AppBar sx={appBarSx}>
				<Toolbar>
					<IconButton
						edge="start"
						color="inherit"
						onClick={handleClose}
						aria-label="close"
						size="large">
						<CloseIcon />
					</IconButton>
					<Typography variant="h6" sx={titleSx}>
						{title}
					</Typography>
					<Button autoFocus color="inherit" onClick={handleClose}>
						close
					</Button>
				</Toolbar>
			</AppBar>
			{dlgCmp}
		</Dialog>
	);
}
export default FullScreenDialog;
